@if (isLoggingOut()) {
  <div class="logout-overlay">
    <div class="logout-content">
      <at-spinner text="Logging out..." />
    </div>
  </div>
}

<div class="wrapper">
  @if (isHeaderVisible()) {
    <app-header-wrapper />
  }

  <main class="main">
    <router-outlet />
  </main>

  @if (isUIVisible()) {
    <at-footer appCookieSettingsLinks [class.has-sidebar]="isSidebarVisible()" [links]="footerLinks">
      <p class="footer-text">© 2026 AnotherTrip. All rights reserved.</p>
    </at-footer>
  }
</div>

@if (!isLoggingOut()) {
  <app-map-job-notices />
}
